/**
 * 执行管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>执行管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <!-- <el-form-item label="搜索"></el-form-item> -->
       <el-form-item label="任务状态：">
        <el-select size="small" v-model="formInline.status" style="width:120px" placeholder="请选择">
          <el-option v-for="type in executeStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleImport">导入</el-button>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportCheck" title="将导出所有勾选的数据">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="exportAll" title="将导出所有满足条件的数据">导出全部</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="handleExport" title="批量导入用户">用户导入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" @click="sendAll" title="批量发送通知消息">发送消息</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="email" align="center" label="接受者邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="task_name" align="center" label="任务名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="param" align="center" label="邮件参数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="send_email" align="center" label="发送者邮箱" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="任务状态" :formatter="statusFormat" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="mobile" align="center" label="头像" width="80px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.pc_head">
        　  <img :src="scope.row.pc_head" width="40" height="40" class="head_pic"/>
        </template>
      </el-table-column> -->
      <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="send_time" align="center" label="发送时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="180px">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click="handleInfo(scope.$index, scope.row)" title="查看详情和推广记录">详情</el-button>
          <el-button size="mini" @click="handleSeller(scope.$index, scope.row)" title="将账户设置为商务">商务</el-button> -->
          <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" title="发送消息通知">编辑</el-button>
          <el-button size="mini" type="danger" @click="delEmail(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm" :rules="infoFormRules">
        <el-form-item label="任务名称" prop="name">
          <el-input size="small" v-model="infoForm.name" auto-complete="off" placeholder="请输入任务名称"></el-input>
        </el-form-item>
        <el-form-item label="任务描述" prop="desc">
          <el-input size="small" v-model="infoForm.desc" auto-complete="off" placeholder="请输入任务描述"></el-input>
        </el-form-item>
        <el-form-item label="应用模板：" prop="temp_id">
          <el-select size="small" v-model="infoForm.temp_id" style="width:300px" placeholder="请选择">
            <el-option v-for="type in taskArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务状态" prop="status">
                <el-radio-group type="kind" v-model="infoForm.status"> 
                    <el-radio v-model="infoForm.status" :label="1">否</el-radio>
                    <el-radio v-model="infoForm.status" :label="2">是</el-radio>
                </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="confirmEditEmail">提交</el-button>
          <el-button size="mini" @click='closeDialog("infoForm")'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 上传excel页面 -->
    <el-dialog :title="title" :visible.sync="excelFormVisible" width="50%" @click="closeDialog('excelForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="关联任务：" prop="task_id">
              <el-select size="small" v-model="excelForm.task_id" style="width:300px" placeholder="请选择" @change="taskIdChange">
                <el-option v-for="type in taskArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传excel：" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M
                    <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载批量导入excel模板">下载模板</span>
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getExecuteList, delTask, editTask, getTemplate, webUrl, getTask } from '../../api/webMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, // 是显示加载
      editFormVisible: false, // 控制编辑页面显示与隐藏
      excelFormVisible: false, // 控制excel导入页面显示与隐藏
      title: '用户详情',
      infoForm: {
        id: 0,
        name: '',
        desc: '',
        status: '',
        temp_id: ''
      },
       formInline: {
        page: 1,
        ps: 10,
        status: 0
      },
      excelForm: {
        task_id: ''
      },
      listData: [], //列表数据
      executeStatus: [
        { key: '全部', value: 0 },
        { key: '未发送', value: 1 },
        { key: '发送成功', value: 2 },
        { key: '发送失败', value: 3 },
      ],
      taskArr: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       // 表单验证
      infoFormRules: {
        name: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        desc: [
          { required: true, message: '请输入任务描述', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择任务状态', trigger: 'blur' }
        ],
        temp_id: [
          { required: true, message: '请选择应用模板', trigger: 'blur' }
        ]
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel: webUrl + '/admin/email/ImportExecute?task_id=',
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
      
          return false
        }
        let taskId = that.excelForm.task_id
        if(!taskId){
          that.$message({
              type: 'error',
              message: '未选择关联任务!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束



    // 查询邮箱列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getExecuteList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      // this.formInline.ps = 10,
      this.getdata(this.formInline)
    },
    // 显示添加界面
    handleAdd() {
      return false
    },
    // 显示编辑界面
    handleEdit(index, row) {
      return false
    },
    // 显示导入界面
    handleImport() {
      getTask()
      .then(res=>{
        if(res.code == 200){
          this.taskArr = res.data
          this.title = 'excel导入'
          this.excelFormVisible = true
        }
      })
      .catch(()=>{
        this.$message({
          type: 'error',
          message: '系统错误'
        })
      })
      
    },
    // 确认提交邮箱编辑
    confirmEditEmail() {
      let sendData = 'infoForm'
      this.$refs[sendData].validate(valid => {
        if(valid){
          let param = this.infoForm
            editTask(param)
            .then(res => {
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.editFormVisible = false
                this.getdata(this.formInline)
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.$message.error('系统错误!')
            })
        }else{
          return false;
        }
    })
    },
    // 删除执行任务
    delEmail(index, row) {
    this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {id:row.id}
          delTask(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试!')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     // 任务状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '未发送'
        }else if(row.status == 2){
            return '发送成功'
        }else if(row.status == 3){
            return '发送失败'
        }else{
            return '未知'
        }
    },
    // 任务下拉框值发生变化
    taskIdChange(val) {
      let newUrl = this.uploadExcel + val
      console.log(newUrl)
      this.uploadExcel = newUrl
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'infoForm'){
        this.editFormVisible = false
      }
      this.$refs[formName].resetFields()
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.invite_item {
  height: 600px;
  overflow-y: auto;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/mail/execute.vue